import { apiEnv } from './client';

export function base64UrlEncode(arrayBuffer) {
  const base64 = btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)));
  return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function generateCodeVerifier() {
  const array = new Uint32Array(56);
  window.crypto.getRandomValues(array);
  return base64UrlEncode(array);
}

export async function generateCodeChallenge(codeVerifier) {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return base64UrlEncode(hash);
}

export const createLoginUrl = async (prompt = true) => {
  const getCurrentDomain = () => `${window.location.protocol}//${window.location.host}`;
  const getEncodedPath = () => {
    const path = `${window.location.pathname}${window.location.search}`;
    return encodeURIComponent(path);
  };
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);

  localStorage.setItem('code_verifier', codeVerifier);

  const queryParams = {
    scope: apiEnv[apiEnv.env].scope,
    response_type: apiEnv[apiEnv.env].response_type,
    redirect_uri: `${getCurrentDomain()}/homepage`,
    state: `${getEncodedPath()}`,
    client_id: apiEnv[apiEnv.env].client_id_login,
    code_challenge: codeChallenge,
    code_challenge_method: apiEnv[apiEnv.env].code_challenge_method,
    //state: apiEnv[apiEnv.env].state,
    nonce: apiEnv[apiEnv.env].nonce,
  };
  const url = `${apiEnv[apiEnv.env].loginUrl(apiEnv[apiEnv.env].policy)}?${Object.keys({
    ...queryParams,
    ...(prompt ? {} : { prompt: apiEnv[apiEnv.env].prompt }),
  })
    .map(
      (key) => `${key}=${
        {
          ...queryParams,
          prompt: apiEnv[apiEnv.env].prompt,
        }[key]
      }`,
    )
    .join('&')}`;
  return url;
};

export const createMailToLink = (to, subject, body) => {
  const a = document.createElement('a');
  a.href = `mailto:${to}?Subject=${encodeURIComponent(
    subject,
  )}&body=${encodeURIComponent(body)}`;
  return a;
};
